<span #stickyPopover="stickyPopover"
      [stickyPopover]="popContent"
      [popoverTitle]="popTitle"
      [autoClose]="false"
      [animation]="false"
      [openDelay]="300"
      popoverClass='preview-popover'
      placement="right-bottom"
      container="body"
      style="font-size: 15px">
    <i class="fa-light fa-image"></i>
</span>

<ng-template #popTitle>
  <i class="fa-light fa-image me-1"></i>Previews for {{row.sourceName}}
</ng-template>

<ng-template #popContent>
  <ng-container *ngIf="!isLoading; else loading">
    <ul ngbNav #nav="ngbNav" class="nav-tabs" [animation]="false" [destroyOnHide]="false">
      <li ngbNavItem *ngFor="let previewsCollection of previewsCollections">
        <a ngbNavLink>{{previewsCollection.name}}</a>
        <ng-template ngbNavContent>
          <div class="btn-group btn-group-sm py-2">
            <button *ngFor="let readmeFile of previewsCollection.readmeFiles; index as i;"
                    id="{{'previews-readme-file-' + i}}"
                    type="button"
                    class="btn btn-link"
                    (click)="openFileInANewTab(readmeFile)">
              README
            </button>
            <button *ngFor="let qa2File of previewsCollection.qa2Files; index as i;"
                    id="{{'previews-qa2-file-' + i}}"
                    type="button"
                    class="btn btn-link"
                    (click)="openFileInANewTab(qa2File)">
              QA2 report
            </button>
            <button *ngFor="let weblogFile of previewsCollection.weblogFiles; index as i;"
                    id="{{'previews-weblog-file-' + i}}"
                    type="button"
                    class="btn btn-link"
                    (click)="openFileInANewTab(weblogFile)">
              Weblog
            </button>
          </div>
          <div style="overflow-y: auto;max-height: 50vh;">
            <ng-container *ngFor="let preview of previewsCollection.previews">
              <asax-result-table-cell-preview [preview]="preview"
                                              [thumbnailFile]="cellPreviewsService.getFile(preview.thumbnailFile)"
                                              (outCartaFile)="openCartaModal($event)">
              </asax-result-table-cell-preview>
            </ng-container>
          </div>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </ng-container>
</ng-template>

<ng-template #loading>
  <div class="d-flex justify-content-center">
    <div class="spinner-border spinner-border-sm" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</ng-template>

<ng-template #cartaModalTemplate>
  <div class="modal-header bg-primary" style="padding: 5px !important">
    <h4 class="modal-title text-white">
      <img src="assets/images/carta_logo.png" class="me-2">CARTA
    </h4>
    <button 
      *ngIf="cartaSocketUrl && !isLoading" 
      class="btn float-end"
      (click)="openCartaInANewTab()" 
      style="color: white;">
      <i class="fa-light fa-up-right-from-square me-1"></i>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="!cartaSocketUrl"
         class="d-flex justify-content-center align-items-center"
         style="height: 75vh">
      <div class="spinner-border spinner-border-sm" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div *ngIf="cartaSocketUrl">
      <iframe [src]="cartaSocketUrl | safe : 'resourceUrl'"
              class="w-100"
              style="height: 75vh">
      </iframe>
    </div>
  </div>
</ng-template>
